import React from "react";
import Index from "../_components/Security/Index";

function SecurityAndCompliancesPage() {
    return <Index />
}

export default SecurityAndCompliancesPage;